import React from 'react';
type FrameworkFlowProps = {
  className?: string;
};
const steps = ['Open', 'Choose', 'Coach'];
export function FrameworkFlow({
  className = ''
}: FrameworkFlowProps) {
  return <ul className={`flex items-center justify-center gap-2 ${className}`} aria-label="Open, Choose, Coach framework" data-id="element-54" data-mp="3h1utl1e3bzs0">
      {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-55" data-mp="3d2ce4l51ggwk" data-mpi={index}>
          <span className="font-display text-[0.8rem] font-semibold uppercase tracking-[0.18em] text-ivory sm:text-[0.9rem]" data-id="element-56" data-mp="dk2z9gchf3qn">
            {step}
          </span>
          {index < steps.length - 1 ? <span className="text-[0.6rem] leading-none text-orange" aria-hidden="true" data-id="element-57" data-mp="3u08lmsu21vh">
              ●
            </span> : null}
        </li>)}
    </ul>;
}